import { useLocalStorage } from "@/hooks/common/useLocalStorage";
import { toUnique } from "@/utils/common/array.utils";

import {
  NavLinkItem,
  NavLinkItemType,
  NavLinkItemTypeValues,
  useNavLinkItemFilter,
} from "../NavLink";

export const useNavLinksState = () => {
  const filterNavLinkItem = useNavLinkItemFilter();
  const [favorites_, setFavorites] = useLocalStorage<NavLinkItem[]>("favorites", []);
  const favorites = favorites_
    .filter((favorite) => NavLinkItemTypeValues.includes(favorite.type))
    .filter((favorite) => filterNavLinkItem(favorite.type));

  const moveFavoriteUp = (type: NavLinkItemType) => {
    setFavorites((prevState) => {
      const oldLinkIndex = prevState.findIndex((item) => item.type === type);
      if (oldLinkIndex === -1 || oldLinkIndex === 0) return prevState;
      const newLinkIndex = oldLinkIndex - 1;
      const newFavorites = [...prevState];
      const [removed] = newFavorites.splice(oldLinkIndex, 1);
      newFavorites.splice(newLinkIndex, 0, removed);
      return newFavorites;
    });
  };

  const moveFavoriteDown = (type: NavLinkItemType) => {
    setFavorites((prevState) => {
      const oldLinkIndex = prevState.findIndex((item) => item.type === type);
      if (oldLinkIndex === -1 || oldLinkIndex === prevState.length - 1) return prevState;
      const newLinkIndex = oldLinkIndex + 1;
      const newFavorites = [...prevState];
      const [removed] = newFavorites.splice(oldLinkIndex, 1);
      newFavorites.splice(newLinkIndex, 0, removed);
      return newFavorites;
    });
  };

  const isFavorite = (type: NavLinkItemType) => {
    return favorites.some((item) => item.type === type);
  };

  const addToFavorites = (item: NavLinkItem) => {
    setFavorites((prevState) => {
      const newFavorites = toUnique([...prevState, item], (a, b) => a.type === b.type);
      return newFavorites;
    });
  };

  const removeFromFavorites = (item: NavLinkItem) => {
    setFavorites((prevState) => {
      const newFavorites = prevState.filter((i) => i.type !== item.type);
      return newFavorites;
    });
  };

  return {
    favorites,
    moveFavoriteUp,
    moveFavoriteDown,
    isFavorite,
    addToFavorites,
    removeFromFavorites,
  };
};
